import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';
import { Box } from '../../atoms/Box';

export const RoleBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'flush',
})<{ flush?: boolean }>`
  box-sizing: border-box;
  ${({ flush }) =>
    flush
      ? `
  width: 100%;
  `
      : `
  width: 97%;
  padding: 10px;
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  `}
`;

export const ContactGridContainer = styled(Grid)`
  margin-bottom: 10px;
`;
